/* eslint 'array-callback-return': 'off','no-new-object': 'off','no-array-constructor': 'off','no-redeclare': 'off', 'jsx-a11y/anchor-is-valid': 'off'  */
import React, { Component } from 'react';
import SearchInput, { createFilter } from 'react-search-input';
import { Table } from 'reactstrap';

const KEYS_TO_FILTERS = ['Name','Location'];

export default class SearchableDropDown extends Component {

    constructor(props) {
        super(props);
        this.state = {
            searchTerm: '',
        }
        this.searchUpdated = this.searchUpdated.bind(this);
        this.selectOption = this.selectOption.bind(this);
    }   

    searchUpdated(term) {
        this.setState({ searchTerm: term })
    }

    selectOption(id,name,location,subId){
        this.props.setValue(id,name,location,subId);
    }

    UnCheckAll(){
        // var CheckBox = document.getElementsByClassName('rdlTenantAndEquipment');
        // for(var i=0; i<CheckBox.length; i++){
        //     CheckBox[i].checked = false;
        // }
        this.props.setValue(0,'','','');
    }

    render(){
        var data = this.props.data;
        let FilteredData, Tenants;
        let SelectedData ='';

        if (data !== undefined && data.length > 0 && data !== null) {

            FilteredData = data.filter(createFilter(this.state.searchTerm, KEYS_TO_FILTERS));
            if (FilteredData.length !== 0) {
                Tenants = FilteredData.map((el,index) =>{
                    var HasChecked = this.props.selectedID === el.Id && (this.props.selectedLocation === el.Location || el.SubId === 1)? true : false;
                    if(HasChecked){
                        SelectedData = el;
                    }else{
                    return <tr key={index}>
                        <th style={{width:"5%", bordertop: "0 solid"}}><input type="radio" className="rdlTenantAndEquipment" checked={HasChecked}  id={el.Id} name={this.props.groupname} data-value={el.Name} onChange={() =>{this.selectOption(el.Id,el.Name,el.Location,el.SubId)}}/></th>
                        <td style={{width:"50%", bordertop: "0 solid"}}>{el.Name}</td>
                        <td style={{width:"45%", bordertop: "0 solid"}}>{el.Location}</td>
                    </tr>
                        }
                    });
                }
            else {
                Tenants = <tr><td colSpan="3">No Records found</td></tr>
            }
        }
        else {
               Tenants = <tr><td colSpan="3">No Records found</td></tr>
        }
        return(
            <div ref={this.props.refMethod} style={this.props.elementStyle}>
            <SearchInput className="search-input multiselect" onChange={this.searchUpdated} style={{width:"370px",float:"right","margin-top":"5px","margin-bottom":"5px","margin-left":"6px","margin-right":"6px",height:'40px'}} />
                <Table style={{ bordertop: "0 solid" }}>
                    <tbody>
                        <tr>
                            <th></th>
                            <th>Name</th>
                            <th>
                                Location
                                <a className="nv_link link_cursor" style={{"width":"39px","float":"right"}} onClick={() => { this.UnCheckAll()}}>Reset</a>
                            </th>
                        </tr>
                        {
                            SelectedData !== ""?
                            <tr key={SelectedData.tenantId}>
                                <th style={{width:"5%", bordertop: "0 solid"}}><input type="radio" className="rdlTenantAndEquipment" checked="true"  id={SelectedData.Id} name={this.props.groupname} data-value={SelectedData.Name} onChange={() =>{this.selectOption(SelectedData.Id,SelectedData.Name,SelectedData.Location,SelectedData.SubId)}}/></th>
                                <td style={{width:"50%", bordertop: "0 solid"}}>{SelectedData.Name}</td>
                                <td style={{width:"45%", bordertop: "0 solid"}}>{SelectedData.Location}</td>
                            </tr>:""
                        }
                        {Tenants}
                    </tbody>
                </Table>
            </div>
        );
    }
}